import axios from "axios";

axios.defaults.withCredentials = false;

const state = {
  userInfo: null,
  error: null,
  isAuthenticated: false,
  subscriptionInfo: null,
  instructorInfo: null,
  notificationCount: null,
  permissionList: [],
  navScrollPosition: 0,
  notificationSocket: null,
  onNewNotifi: null,
  notificationData: null,
  // SOCKET STATE
  socket: null,
  messageCount: 0,
  onNewMessage: null,
  loginDurationInfo: null,
  loginDuration: null,
};
const savedUser = localStorage.getItem("userInfo");
if (savedUser) {
  const parsed = JSON.parse(savedUser);
  state.userInfo = parsed;
  state.isAuthenticated = true;
}

const getters = {
  notificationData: (state) => state.notificationData,
  userInfo: (state) => state.userInfo,
  loginError: (state) => state.error,
  isAuthenticated: (state) => state.isAuthenticated,
  subscriptionInfo: (state) => state.subscriptionInfo,
  instructorInfo: (state) => state.instructorInfo,
  notificationCount: (state) => state.notificationCount,
  permissionList: (state) => state.permissionList,
  getNavScrollPosition: (state) => state.navScrollPosition,
  isSocketConnected: (state) =>
    state.notificationSocket &&
    state.notificationSocket.readyState === WebSocket.OPEN,
  isMsgSocketConnected: (state) =>
    state.socket && state.socket.readyState === WebSocket.OPEN,
  messageCount: (state) => state.messageCount,
};

const actions = {
  async logoutLoginDuration({ state, commit }) {
    try {
      if (!state.loginDuration?.id) {
        console.warn("No login-duration ID found, PATCH skipped");
        return;
      }

      const payload = {
        loged_out: new Date().toISOString(),
      };

      const response = await axios.patch(
        `${process.env.VUE_APP_API}/login-duration/${state.loginDuration.id}/?Key=${state.userInfo.token_key}`,
        payload,
      );

      commit("SET_LOGIN_DURATION", response.data.data);

      return response.data.data;
    } catch (error) {
      console.error("Logout duration PATCH failed", error);
      throw error;
    }
  },

  async postLoginDuration({ commit, state }, payload) {
    try {
      if (!state.userInfo || !state.userInfo.user) {
        console.warn("User info not available for login duration");
        return;
      }

      const requestPayload = {
        user: state.userInfo.user.id,
        ip_address: payload.ip_address,
        loged_in: new Date().toISOString(),
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API}/login-duration/creation/?Key=${state.userInfo.token_key}`,
        requestPayload,
      );

      commit("SET_LOGIN_DURATION", response.data.data);
      return response.data;
    } catch (error) {
      console.error("Login duration API error:", error);
      throw error;
    }
  },

  initApp({ state, dispatch }) {
    if (state.userInfo && state.userInfo.user && state.userInfo.token_key) {
      dispatch("connectMessageSocket", {
        userId: state.userInfo.user.id,
        token: state.userInfo.token_key,
      });
    }
  },
  connectWebSocket({ state, commit }) {
    try {
      const stored = localStorage.getItem("userInfo");
      const userInfo = stored ? JSON.parse(stored) : state.userInfo;

      if (!userInfo || !userInfo.user || !userInfo.token_key) {
        console.warn("No userInfo found → WebSocket not connecting");
        return;
      }

      const userId = userInfo.user.id;
      const tokenKey = userInfo.token_key;

      if (
        state.notificationSocket &&
        state.notificationSocket.readyState === WebSocket.OPEN
      ) {
        console.log("WebSocket already connected");
        return;
      }

      const socketUrl = `${process.env.VUE_APP_SOCKET_URL}/ws/notifications-count/${userId}/?Key=${tokenKey}`;

      const socket = new WebSocket(socketUrl);
      commit("setNotificationSocket", socket);

      socket.onopen = () => {
        console.log("WebSocket Connected Successfully!");
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          commit("setNotificationData", data);
          if (data.count !== undefined) {
            commit("notifyCount", data.count);
          }
        } catch (err) {
          console.error("WS message parse error:", err);
        }
      };
      socket.onerror = (err) => {
        console.error("WebSocket Error:", err);
      };
      socket.onclose = (event) => {
        console.warn("WebSocket Closed", {
          code: event.code,
          reason: event.reason || "No reason provided",
          wasClean: event.wasClean,
        });
        commit("setNotificationSocket", null);
      };
    } catch (err) {
      console.error("WebSocket init error:", err);
    }
  },

  async initializeApp({ commit, dispatch }) {
    try {
      const storedUser = localStorage.getItem("userInfo");

      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser);

          if (userData && userData.token_key) {
            console.log(
              "User info found in localStorage, restoring session...",
            );

            commit("setUserInfo", userData);

            console.log(" Reconnecting WebSocket after page refresh...");
            dispatch("connectWebSocket");

            try {
              const featuresResp = await axios.get(
                `${process.env.VUE_APP_API}/features/?Key=${userData.token_key}`,
              );
              if (
                featuresResp.data.code === 200 &&
                featuresResp.data.message?.[0]?.features
              ) {
                commit("StorePermisson", featuresResp.data.message[0].features);
              }
            } catch (error) {
              console.error(" Error fetching permissions:", error);
            }
          }
        } catch (parseError) {
          console.error("Error parsing stored user data:", parseError);
          localStorage.removeItem("userInfo");
        }
      } else {
        console.log("ℹ No active session found");
      }
    } catch (error) {
      console.error("Error initializing app:", error);
    }
  },
  async loginWithGoogle({ commit, dispatch }, gooleUser) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API}/google-login/`,
        gooleUser,
      );

      if (response.data.token_key) {
        commit("setUserInfo", response.data);
        dispatch("connectWebSocket");

        axios
          .get(
            `${process.env.VUE_APP_API}/features/?Key=${response.data.token_key}`,
          )
          .then((resp) => {
            if (resp.data.code == 200 && resp.data.message?.[0]?.features) {
              commit("StorePermisson", resp.data.message[0].features);
            }
          });

        axios
          .get(
            `${process.env.VUE_APP_API_COMS}/login/get-user-token/?email=${response.data.user.email}&Key=bcd3f22f86e61b7fcaa05ecbf32f874ee855c1bc`,
          )
          .then((response) => {
            if (response.data) {
              localStorage.setItem("LmsId", response.data.message.Key);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        commit("errMessage", response.data.error);
        setTimeout(() => {
          commit("errMessage", "");
        }, 3000);
      }
    } catch (error) {
      commit("errMessage", error.response?.data?.error || "Login failed");
      setTimeout(() => {
        commit("errMessage", "");
      }, 3000);
    }
  },

  async loginUser({ commit, dispatch }, credentials) {
    try {
      const response = await fetch(`${process.env.VUE_APP_API}/login`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        requiredStatus: "ok",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
          "User-Agent": navigator.userAgent,
        },
        body: JSON.stringify(credentials),
      });
     

      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const data = await response.json();
      const res = { data, status: response.status };

      if (res.data.token_key) {
        commit("setUserInfo", res.data);

        // await dispatch("postLoginDuration", {
        //   ip_address: credentials.ip_address,
        // });

        commit("setNavScrollPosition", 0);
        dispatch("connectWebSocket");
        const lmsId =
          res.data.user.permission === "student"
            ? "f12174911b735d6b5a334e00d31c29f7481e1449"
            : "e7b83f42ec70e604a281ead8732bc8634f264eec";
        localStorage.setItem("LmsId", lmsId);

        // ✅ Fetch COMS token
        // axios
        //   .get(
        //     `${process.env.VUE_APP_API_COMS}/login/get-user-token/?email=${res.data.user.email}&Key=bcd3f22f86e61b7fcaa05ecbf32f874ee855c1bc`
        //   )
        //   .catch((error) => console.error("COMS Token Error:", error));

        // ✅ Fetch permissions
        axios
          .get(`${process.env.VUE_APP_API}/features/?Key=${res.data.token_key}`)
          .then((resp) => {
            if (resp.data.code === 200 && resp.data.message?.[0]?.features) {
              commit("StorePermisson", resp.data.message[0].features);
            }
          })
          .catch((error) => console.error("Feature fetch error:", error));

        dispatch("connectMessageSocket", {
          userId: res.data.user.id,
          token: res.data.token_key,
        });
        return res.data;
      } else {
        commit("errMessage", res.data.error);
        setTimeout(() => commit("errMessage", ""), 3000);
      }
    } catch (error) {
      commit("errMessage", error);
      setTimeout(() => commit("errMessage", ""), 3000);
    }
  },

  async logOutUser({ commit, state, dispatch }) {
    const response = await axios.get(`${process.env.VUE_APP_API}/singout`);
    commit("closeWebSocket");
    if (state.loginDuration?.id) {
      await dispatch("logoutLoginDuration");
    }
    commit("CLOSE_SOCKET");
    localStorage.removeItem("LmsId");
    localStorage.removeItem("userInfo");
    commit("SET_LOGIN_DURATION", null);
    commit("logout", response.data);
    commit("setNavScrollPosition", 0);
  },

  async subcription({ commit }, subdata) {
    const response = await axios.get(
      `${process.env.VUE_APP_API}/userpermissionlist/?Key=${subdata.token_key}`,
    );
    if (response && response.data.message == "Have a details") {
      commit("subdetails", response.data.data);
    } else {
      let message = "Nothing to show";
      commit("subdetails", message);
    }
  },

  async instructordetails({ commit }, subdata) {
    const response = await axios.get(
      `${process.env.VUE_APP_API}/instructor/?Key=${subdata.token_key}`,
    );
    if (response && response.data.data) {
      commit("instructorInfos", response.data);
    } else if (response && response.data.error) {
      let message = "Nothing to show";
      commit("instructorInfos", message);
    } else if (response == undefined) {
      let message = "500 Error";
      commit("instructorInfos", message);
    } else {
      let message = "Please check your internet connection";
      commit("instructorInfos", message);
    }
  },

  connectMessageSocket({ commit, state, dispatch }) {
    if (!state.userInfo) return;

    const userId = state.userInfo.user.id;
    const token = state.userInfo.token_key;

    if (state.socket && typeof state.socket.close === "function") {
      try {
        state.socket.onclose = null;
        state.socket.onerror = null;
        state.socket.close();
      } catch (e) {
        console.error("❌ Error closing existing WebSocket:", e);
      }
    }

    const wsUrl = `${process.env.VUE_APP_SOCKET_URL}/ws/message-details/${userId}/?Key=${token}`;
    const socket = new WebSocket(wsUrl);
    commit("SET_SOCKET", socket);

    // socket.onopen = () => console.log("🟢 WebSocket connected:", wsUrl);
    socket.onopen = () => {};

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.count !== undefined) {
        commit("SET_MESSAGE_COUNT", data.count);
      }

      // Trigger parent page callback to reload message list
      if (typeof state.onNewMessage === "function") {
        state.onNewMessage();
      }
    };

    socket.onclose = () => {
      setTimeout(() => dispatch("connectMessageSocket"), 3000);
    };

    socket.onerror = (err) => console.error("WebSocket error:", err);
  },

  async fetchMessageList(_, { userId, token, page = 1 }) {
    const res = await axios.get(
      `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${userId}&Key=${token}&page=${page}`,
    );
    return res.data.data;
  },
  async fetchNotificationList(_, { userId, token, page = 1 }) {
    const res = await axios.get(
      `${process.env.VUE_APP_API}/notifications/${userId}/?Key=${token}&page=${page}`,
    );
    return res.data.data;
  },
};

const mutations = {
  SET_LOGIN_DURATION(state, payload) {
    state.loginDuration = payload;
  },

  setNavScrollPosition(state, position) {
    state.navScrollPosition = position;
  },
  setNotificationSocket(state, socket) {
    state.notificationSocket = socket;
  },
  setNotificationData(state, data) {
    state.notificationData = data;
  },
  SET_ON_NEW_NOTIFICATION(state, callback) {
    state.onNewNotifi = callback;
  },
  StorePermisson: (state, data) => {
    state.permissionList = data;
  },
  setUserInfo: (state, data) => {
    state.userInfo = data;
    state.isAuthenticated = true;
    state.error = null;
    localStorage.setItem("userInfo", JSON.stringify(data));
  },
  errMessage: (state, data) => {
    state.error = data;
  },
  logout: (state) => {
    state.userInfo = null;
    state.isAuthenticated = false;
    state.subscriptionInfo = null;
    state.instructorInfo = null;
    state.notificationSocket = null;
    state.notificationData = null;
    // Clear localStorage on logout
    localStorage.removeItem("userInfo");
    localStorage.clear();
  },
  subdetails: (state, data) => {
    state.subscriptionInfo = data;
  },
  instructorInfos: (state, data) => {
    state.instructorInfo = data;
  },
  notifyCount: (state, data) => {
    state.notificationCount = data;
  },
  updateImage: (state, data) => {
    state.userInfo.image = data;

    const savedUser = localStorage.getItem("userInfo");
    if (savedUser) {
      const user = JSON.parse(savedUser);
      user.image = data;
      localStorage.setItem("userInfo", JSON.stringify(user));
    }
  },

  closeWebSocket(state) {
    if (state.notificationSocket) {
      try {
        state.notificationSocket.close();
      } catch (e) {
        console.error("❌ Error closing WebSocket:", e);
      }
      state.notificationSocket = null;
    }
  },

  // Message socket
  SET_SOCKET(state, socket) {
    state.socket = socket;
  },
  SET_MESSAGE_COUNT(state, count) {
    state.messageCount = count;
  },
  SET_ON_NEW_MESSAGE(state, callback) {
    state.onNewMessage = callback;
  },

  CLOSE_SOCKET(state) {
    if (state.socket) {
      try {
        state.socket.onclose = null;
        state.socket.close();
      } catch (e) {
        console.error("❌ Error closing WebSocket:", e);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
